import {type DiceSettingEnum} from '@colonist/types'
import {type ModeSettingEnum} from '@colonist/game-base-types'
import {GameModeDataController, GAME_TIMER_OPTIONS} from '@colonist/shared-types'
import {type PlayerEnums} from '../../../../shared/GameEnums.ts'
import {StorageWrapper} from '../StorageWrapper.ts'
import {socket} from '../EntryShared.ts'

export class UIRoomSettingsController {
    static initRoomSettingFromLocalStorage(modeSetting: ModeSettingEnum): void {
        const diceSetting = UIRoomSettingsController.getLocalStorageDiceSettings()
        if(diceSetting != undefined) socket.roomClient.setDiceType(diceSetting)

        const friendlyRobberActive = UIRoomSettingsController.getLocalStorageFriendlyRobberSettings()
        if(friendlyRobberActive != undefined) socket.roomClient.setFriendlyRobber(friendlyRobberActive)

        const gameSpeedSetting = UIRoomSettingsController.getLocalStorageGameSpeedSettings()
        if(gameSpeedSetting != undefined) {
            const speedSettingToUse = UIRoomSettingsController.getSpeedSettingToUse(modeSetting, gameSpeedSetting)
            socket.roomClient.setGameSpeed(speedSettingToUse)
        }
    }

    private static getLocalStorageDiceSettings(): DiceSettingEnum | undefined {
        const diceSetting = StorageWrapper.getRoomDiceSetting()
        if(diceSetting == null) return undefined
        return diceSetting
    }

    private static getLocalStorageFriendlyRobberSettings(): boolean | undefined {
        const friendlyRobberActive = StorageWrapper.getRoomFriendlyRobberActiveSetting()
        if(friendlyRobberActive == null) return undefined
        return friendlyRobberActive
    }

    private static getLocalStorageGameSpeedSettings(): PlayerEnums.GameSpeedSettings | undefined {
        const gameSpeedSetting = StorageWrapper.getRoomGameSpeedSetting()
        if(gameSpeedSetting == null) return undefined
        return gameSpeedSetting
    }

    private static getSpeedSettingToUse(modeSetting: ModeSettingEnum, gameSpeedSetting: PlayerEnums.GameSpeedSettings): PlayerEnums.GameSpeedSettings {
        const gameModeData = GameModeDataController.getModeDataForMode(modeSetting)
        if(gameModeData == undefined) return gameSpeedSetting
        const defaultSpeedSettingForMode = gameModeData.allowedGameTimers.find((t) => GAME_TIMER_OPTIONS[t].isDefault) ?? gameModeData.allowedGameTimers[0]
        const isCurrentSpeedAllowed = gameModeData.allowedGameTimers.some((t) => t === gameSpeedSetting)
        return isCurrentSpeedAllowed ? gameSpeedSetting : defaultSpeedSettingForMode
    }
}
